import change from '@/store/modules/pto/project/change'
import statement from '@/store/modules/pto/project/statement'
import document from '@/store/modules/pto/project/document'
import pto from '@/store/modules/pto/project/pto'
import estimate from '@/store/modules/pto/project/estimate'

import { vuexPto } from '@/store/compositionV2/module/pto'
import { PTOProjectApi } from '@/api/pto/project'
import { getUserFullName } from '@/utils/user'
import { priceFormat } from '@/utils/form/priceFormat'
import { findById } from '@/utils/array/find'
import { getYesOrNo } from '@/utils/string/getYesOrNo'
import { goToPage } from '@/utils/router'
import { map2mod } from '@/utils/array/map'

const state = () => ({
  ...vuexPto.createState(),
  api: PTOProjectApi,
  namePageDetailed: 'PtoProjectDetailed',
  expand: 'status,i_d,pto_responsible,co_executors,sub_contractor,treaty,ppr_developer,object,changes,statements,supplies,kmds,pprs,estimates,files,updated_by,price,signed,remains',
  tableHeaders: [
    {
      title: 'Дата начала',
      isSortable: true,
      sortName: 'start_date'
    },
    {
      title: 'Дата окончания',
      isSortable: true,
      sortName: 'stop_date'
    },
    {
      title: 'Кто изменил',
      isSortable: true,
      sortName: 'updated_by.surname'
    },
    {
      title: 'Стройка',
      isSortable: true,
      sortName: 'building.name'
    },
    {
      title: 'Объект',
      isSortable: true,
      sortName: 'object.name'
    },
    {
      title: 'Шифр проекта',
      isSortable: true,
      sortName: 'project_cipher'
    },
    {
      title: 'Наименование',
      isSortable: true,
      sortName: 'name'
    },
    {
      title: 'Дата получения',
      isSortable: true,
      sortName: 'receive_date'
    },
    {
      title: 'Нет сметы',
      isSortable: false,
      sortName: 'is_no_estimate'
    },
    {
      title: 'Ответственный ПТО',
      isSortable: false,
      sortName: 'pto_responsible'
    },
    {
      title: 'Ответственный сметный',
      isSortable: true,
      sortName: 'object.estimate_responsible'
    },
    {
      title: 'Стоимость',
      isSortable: true,
      sortName: 'price'
    },
    {
      title: 'Подписано',
      isSortable: true,
      sortName: 'signed'
    },
    {
      title: 'Остаток',
      isSortable: true,
      sortName: 'remains'
    },
    {
      title: 'ИД',
      isSortable: true,
      sortName: 'i_d.name'
    },
    {
      title: 'Статус',
      isSortable: true,
      sortName: 'status.name'
    },
    {
      title: 'Договор',
      isSortable: true,
      sortName: 'treaty.treaty_number'
    }
  ],
  fromPage: false
})

const getters = {
  ...vuexPto.createGetters(),
  getList: state => {
    return state.list.map(item => {
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.start_date || '-',
          item.stop_date || '-',
          getUserFullName(item.updated_by) || '-',
          item.object?.building?.name || '-',
          item.object?.name || '-',
          item.project_cipher || '-',
          item.name || '-',

          item.receive_date || '-',
          getYesOrNo(item.is_no_estimate),
          getUserFullName(item.pto_responsible) || '-',
          getUserFullName(item.object?.estimate_responsible) || '-',

          item.price !== 0 ? priceFormat(item.price) : '-',
          item.signed !== 0 ? priceFormat(item.signed) : '-',
          item.remains !== 0 ? priceFormat(item.remains) : '-',

          item.i_d?.name || '-',
          item.status?.name || '-',
          item.object?.treaty?.treaty_number || '-'
        ].map(map2mod)
      }
    })
  },
  getCurrentItem: (state, _, rootState) => ({
    ...state.currentItem,
    building: state.currentItem?.object?.building,
    accounting_cipher: state.currentItem?.accounting_cipher,
    general_contractor: findById(rootState.handbook.partner.partnerList, state.currentItem?.object?.general_contractor_id)
  }),
  getChildrenFilter: (_, getters) => {
    return {
      project_id: getters.getCurrentItemId
    }
  }
}

const mutations = {
  ...vuexPto.createMutations()
}

const actions = {
  ...vuexPto.createActions(),

  async goToPageById ({ state }, id) {
    await goToPage(state.namePageDetailed, { projectId: id })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    change,
    statement,
    document,
    pto,
    estimate
  }
}
